import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalComponent} from '@app/shared/components/modal/modal.component';
import {User} from '@app/shared/models';
import {UserBusinessType} from '@app/shared/models/enums/user-business-type.enum';

@Component({
    selector: 'app-user-details-modal',
    templateUrl: './user-details-modal.component.html',
    styleUrls: ['./user-details-modal.component.scss']
})
export class UserDetailsModalComponent {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() canManageUsers = false;
    @Input() userBusinessTypes = [];

    @Output() resetUser = new EventEmitter<User>();
    @Output() deleteUser = new EventEmitter<User>();
    @Output() updateUser = new EventEmitter<any>();

    selectedUser: User;
    draftIsActive: boolean;
    draftUserBusinessType: UserBusinessType;

    open(user: User) {
        this.selectedUser = user;
        this.draftIsActive = user?.isActive;
        this.draftUserBusinessType = user?.userBusinessType;
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onResetUser() {
        this.resetUser.emit(this.selectedUser);
    }

    onDeleteUser() {
        this.deleteUser.emit(this.selectedUser);
    }

    onUpdateUser() {
        this.updateUser.emit({
            user: this.selectedUser,
            isActive: this.draftIsActive,
            userBusinessType: this.draftUserBusinessType
        });
    }

    get hasChanges() {
        return this.selectedUser &&
            (this.selectedUser.isActive !== this.draftIsActive ||
                this.selectedUser.userBusinessType !== this.draftUserBusinessType);
    }

    businessTypeLabel(user: User) {
        switch (user?.userBusinessType) {
            case UserBusinessType.TechnicalProductionUser:
                return 'admin.users.table.rows.userBusinessType.technicalProductionUser';
            case UserBusinessType.TechnicalToolManagementUser:
                return 'admin.users.table.rows.userBusinessType.technicalToolManagementUser';
            case UserBusinessType.EmployeeUser:
            default:
                return 'admin.users.table.rows.userBusinessType.employeeUser';
        }
    }
}
